export default __webpack_public_path__ + "static/media/13n.c1dccc5e.jpg";